import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { createSearchParams } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import SearchFilter from "../../../../components/CustomeFilter/SearchFilter";
import CustomeTableBtn from "../../../../components/custome-table-button/CustomeTableBtn";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  deleteAttribute,
  retreiveAllGroupAttributes,
} from "../../../../actions/product";
import { Pagination } from "@mui/material";
import EditTabelDrawer from "../../../../components/Edit-tabel-drawer/EditTabelDrawer";
import AddAttributeGroups from "./components/AddAttributeGroups";
import UpdateAttributeGroups from "./components/UpdateAttributeGroups";
import DashboardPagesLayout from "../../customerServiceDashboard/components/DashboardPagesLayout";

const AttributeGroups = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Local State
  const [isMount, setisMount] = useState(false);
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });
  const [SearchFillter, setSearchFillter] = useState({
    SearchQuery: "",
  });
  const [SelectItem, setSelectItem] = useState({});
  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });

  // Api calls for get Order
  const getAllAttributes = useCallback(async () => {
    const res = await dispatch(retreiveAllGroupAttributes());
    setData(res?.attributeGroupes);
    setpagination({
      ...res?.pagination,
    });
    setloading(false);
  }, [dispatch]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }
  }, [window.location.search]);

  useEffect(() => {

    var isSubscribe = true;
    if (isSubscribe) {
      var timer = setTimeout(() => {
        getAllAttributes();
      }, 1000);
    }

    return () => {
      isSubscribe = false;
      clearTimeout(timer);
    };
  }, [
    pagination.currentPage,
    SearchFillter.SearchQuery,
    Edit.open,
    isMount,
    getAllAttributes,
  ]);

  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: window.location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setpagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: window.location.pathname,
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };


  //Delete Category
  const hanldeDeleteConfirm = async (id) => {
    setloading(true);
    const res = await dispatch(deleteAttribute(id));
    if (res) {
      setdeleteConfirm({
        open: false,
        id: null,
      });
      setisMount(!isMount);
      setloading(false);
    }
  };

  // hanlde add new Attributes
  const handleAddNew = () => {
    setEdit({
      open: true,
      edit: "AddNew",
      title: "Add New Attributes Groups",
    });
    setSelectItem({});
  };
  // handle update attribute open
  const handleUpdate = (item) => {
    setEdit({
      open: true,
      edit: "update",
      title: "update Attributes Groups",
    });
    setSelectItem({ ...item });
  };
  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className=" d-flex  justify-content-end align-center">
            <CustomeTableBtn
              className={"mx-2 py-3 px-5"}
              color="secondary"
              width={"100px"}
              onClick={() => handleAddNew()}
            >
              Add New
            </CustomeTableBtn>
            <SearchFilter
              type="text"
              placeholder={"Search Attributes"}
              value={SearchFillter?.SearchQuery}
              onChange={(e) => {
                resetToFirstPage();
                setSearchFillter({
                  ...SearchFillter,
                  SearchQuery: e.target.value,
                });
              }}

            />
          </div>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Attribute Groups"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Name</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td className="order-item-number">{i + 1}</td>
                            <td>{item.name}</td>

                            <td>
                              <CustomeTableBtn
                                color="secondary"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() => handleUpdate(item)}
                              >
                                Edit
                              </CustomeTableBtn>

                              <CustomeTableBtn
                                color="danger"
                                width={"100px"}
                                onClick={() =>
                                  setdeleteConfirm({
                                    open: true,
                                    id: item?._id,
                                  })
                                }
                              >
                                Delete
                              </CustomeTableBtn>

                              {deleteConfirm.open && (
                                <SweetAlert
                                  warning
                                  showCancel
                                  confirmBtnText="Yes, delete it!"
                                  confirmBtnBsStyle="danger"
                                  title="Are you sure?"
                                  onConfirm={(e) => {
                                    hanldeDeleteConfirm(deleteConfirm.id);
                                  }}
                                  onCancel={() =>
                                    setdeleteConfirm({
                                      open: false,
                                      id: null,
                                    })
                                  }
                                  focusCancelBtn
                                >
                                  Are you sure you want to delete?
                                </SweetAlert>
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
                <EditTabelDrawer
                  Edit={Edit}
                  setEdit={setEdit}
                  shippingId={SelectItem?.name}
                >
                  {Edit.edit === "AddNew" && (
                    <AddAttributeGroups setEdit={setEdit} />
                  )}
                  {Edit.edit === "update" && (
                    <UpdateAttributeGroups
                      SelectItem={SelectItem}
                      setEdit={setEdit}
                    />
                  )}

                  <hr className=" mb-0" />
                </EditTabelDrawer>
                <div className="d-flex justify-content-center align-center p-2">
                  <div className=" mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className=" font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {Data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default AttributeGroups;
